import { socket } from '@/socket';
import { adminUpdateState } from '@lc/const/socketEvent';
import { CurrPlayerActionParams } from '@lc/interface/actionParams/types';
import { CurrPlayer } from '@lc/interface/currPlayer/types';
import { GameState } from '@lc/interface/gameState/types';
import { createPayment } from '@lc/interface/payment/factory';

export function sendSocketAction(
	action: string,
	currPlayer: any,
	cardId = -1,
	paymentObject = createPayment(),
	sourceId = -1,
	targetId = -1,
	choiceInt = -1
) {
	socket.emit(action, {
		...currPlayer,
		cardId,

		paymentObject,

		sourceId,
		targetId,
		choiceInt, // of the array of decision given, int of array element choice
	});
}

export function sendSocketActionSimple(
	action: string,
	obj: CurrPlayerActionParams
) {
	socket.emit(action, obj);
}

export function sendAdminState(currPlayer: CurrPlayer, gameState: GameState) {
	socket.emit(adminUpdateState, {
		...currPlayer,
		gameState,
	});
}
